import {GlyphSeries} from '@visx/xychart';
import React from 'react';

import {DataAccessor} from 'ui-library/charting/internals/utils/dataAccessor';
import {NO_SERIES_ERROR_BAR_COLOR} from 'ui-library/charting/internals/utils/Theme';
import {CartesianPoint} from 'ui-library/charting/Types';

import CartesianErrorBar from './CartesianErrorBar';

export interface ErrorBarSeriesProps<DataPoint extends CartesianPoint> {
  color: string;
  data: Array<DataPoint>;
  label?: string;
  xAccessor: DataAccessor<CartesianPoint>;
  yAccessor: DataAccessor<CartesianPoint>;
}

export default function ErrorBarSeries<DataPoint extends CartesianPoint>({
  color,
  data,
  label,
  xAccessor,
  yAccessor,
}: ErrorBarSeriesProps<DataPoint>): JSX.Element | null {
  const errorBarColor = label == null ? NO_SERIES_ERROR_BAR_COLOR : color;

  return (
    <>
      <GlyphSeries
        dataKey={`${label}-error-bars`}
        data={data.filter((point) => point.errorValue != null)}
        xAccessor={xAccessor}
        yAccessor={yAccessor}
        renderGlyph={({x, y, datum: dataPoint}) => (
          <CartesianErrorBar color={errorBarColor} dataPoint={dataPoint} x={x} />
        )}
      />
    </>
  );
}
